import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { displaySuccessToast, displayErrorToast } from "../store/actions/overflowNotification";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

export const useSaveDotsFeedbackToast = (
  saveCommunityTemplateState, isFromSaveDots = false, isDetailPage
) => {
  const dispatch = useDispatch();
  const errorMessage = (
    <div>
      <FormattedMessage id="ask.pages.edit.communityTemplates.saveDotsErrorMessage" />
    </div>
  );
  const successMessage = (
    <>
      <div>
        <FormattedMessage id="ask.pages.edit.communityTemplates.saveDotsSuccessMessage" />
      </div>
      {isDetailPage && (
        <Link to={{ pathname: "/ask-edit", state: isFromSaveDots }}>
          {" "}
          <FormattedMessage id="ask.pages.edit.communityTemplates.saveDotsSuccessLink" />{" "}
        </Link>
      )}
    </>
  );

  useEffect(() => {
    if (saveCommunityTemplateState.ended === true && saveCommunityTemplateState.error === false) {
      dispatch(displaySuccessToast(successMessage, ""));
      if (!isDetailPage) {
        window.location.reload();
      }
    }
    if (saveCommunityTemplateState.ended === true && saveCommunityTemplateState.error === true) {
      dispatch(displayErrorToast(errorMessage, "Errore"));
    }
  }, [saveCommunityTemplateState]);
};
